import { useState, useEffect, useRef } from 'react';

export interface TokenomicsData {
  lpZeus: string;
  lpZeusPct: number;
  lpWeth: number;
  lpZeusUsd: number | null;
  lpWethUsd: number | null;
  lpUsd: number | null;
  lpLockedSharePct: number;
  circulatingZeus: string;
  circulatingPct: number;
  zeusPriceUsd: number | null;
  ethUsd: number | null;
  totalSupply: string;
  block: number;
  updatedAt: number;
}

export function useTokenomics() {
  const [data, setData] = useState<TokenomicsData | null>(null);
  const [failed, setFailed] = useState(false);
  const fetchedRef = useRef(false);

  useEffect(() => {
    if (fetchedRef.current) return;
    fetchedRef.current = true;

    const fetchData = async () => {
      try {
        const res = await fetch('/api/tokenomics-snapshot');
        const json = await res.json();
        if (res.ok && json.success && json.data) {
          setData(json.data);
        } else {
          setFailed(true);
        }
      } catch (err) {
        console.error('Error loading tokenomics snapshot:', err);
        setFailed(true);
      }
    };

    fetchData();
  }, []);

  return { data, failed };
}
